module.exports = __webpack_public_path__ + "img/grid-dots-vertical-center.7a27655f.svg";